import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/img_32.svg")